import { render, staticRenderFns } from "./AiRecommend.vue?vue&type=template&id=1ea00496&scoped=true"
import script from "./AiRecommend.vue?vue&type=script&lang=ts"
export * from "./AiRecommend.vue?vue&type=script&lang=ts"
import style0 from "./AiRecommend.vue?vue&type=style&index=0&id=1ea00496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea00496",
  null
  
)

export default component.exports